// @flow

/**
 * This function checks the presence of the window and document object in order to assert whether the code is
 * running server-side or client-side. window and document are present only client-side.
 * @return {true} -
 */
const isServer = () => {
  return !(typeof window !== 'undefined' && window.document);
};

export default isServer;



// WEBPACK FOOTER //
// ./src/utils/isServer/index.js